import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-radio-button-group',
  templateUrl: './radio-button-group.component.html',
  styleUrls: ['./radio-button-group.component.scss'],
  standalone: false,
})
export class RadioButtonGroupComponent {
  @Input() public formCtrl: FormControl = new FormControl();

  // layout : 'column' | 'row'
  @Input() public layout: string = 'column';

  @Input() public label: string = '';

  @Input() public hintMessage: string = '';

  @Input() public elements: { label: string; value: any; color?: string }[] = [];

  @Input() public disabled: boolean = false;

  @Output() public onValueChanged: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  getSelectedValue(selectedValue: any) {
    if (this.formCtrl) {
      this.onValueChanged.emit(selectedValue);
    }
  }
}
